import React from 'react'
import './QuoteGen.css'
import QuoAuth from "./QuoAuth"
import Bottom from "./Bottom"  

export default function QuoteGen(props)  {
return (
        <div id="quote-box" style={{"height": props.height}} className="well" >
            <QuoAuth currentQuote={props.currentQuote} author={props.author} />
            <Bottom colors={props.colors} counter={props.counter} click={props.click}/>
        </div>
        )
    }

    



